
var stache = require('can/view/stache/stache');
module.exports = stache("{{#if enabled}}\r\n    <script \r\n        async=\"async\"\r\n        id=\"satisfiScript\" \r\n        src=\"https://chat.satis.fi/popup/embedder?popupId=7623\"\r\n    >\r\n    </script>\r\n{{/if}}\r\n");